// client/data-view-controller.ts
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { SubscriptionPagination } from "@adornis/pagination/paginatable.js";
import { combineLatest, distinctUntilChanged, merge, of, switchMap, takeUntil } from "rxjs";
var DataViewController = class {
  constructor(host, dvOptions$) {
    this.host = host;
    // Pagination and Data to show
    this.paginationClass = SubscriptionPagination;
    this.data = [];
    this.loadingInitially = true;
    this.complete = false;
    dvOptions$.pipe(
      switchMap((options) => {
        this._paginationInstance?.stop();
        this._paginationInstance = new this.paginationClass(
          options.operation,
          [options.filter ?? new AdornisFilter({})],
          options.finalSelectionSet
        );
        if (!this._paginationInstance)
          throw new Error("should not happen");
        return combineLatest([
          this._paginationInstance.loadingInitially.pipe(takeUntil(this.host.disconnected), distinctUntilChanged()),
          merge(
            of(false),
            this._paginationInstance.complete.pipe(takeUntil(this.host.disconnected), distinctUntilChanged())
          ),
          merge(of(void 0), this._paginationInstance.data.pipe(takeUntil(this.host.disconnected)))
        ]);
      })
    ).subscribe(([loadingInitially, complete, data]) => {
      this.loadingInitially = loadingInitially;
      this.complete = complete;
      if (data !== void 0)
        this.data = data;
      this.host.requestUpdate();
    });
    (this.host = host).addController(this);
  }
  get totalRequested() {
    return this._paginationInstance?.totalRequested.getValue() ?? 0;
  }
  next() {
    return this._paginationInstance?.next();
  }
  hostConnected() {
  }
  hostDisconnected() {
    this._paginationInstance?.stop();
  }
};
export {
  DataViewController
};
